export function defaultAuditDateRange(days = 30): { from: number; to: number } {
    const normalizedDays = Number.isFinite(days) ? Math.max(1, Math.floor(days)) : 30;
    const now = new Date();
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - (normalizedDays - 1), 0, 0, 0, 0);
    return {
        from: Math.floor(start.getTime() / 1000),
        to: Math.floor(end.getTime() / 1000)
    };
}
